import Vue from "vue";
import Vuex from "vuex";

import alert from "./modules/alert/alert.module";
import user from "./modules/user/user.module";
import balance from "./modules/balance/balance.module";
import HMI from "./modules/hmi/hmi.module";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    alert,
    user,
    balance,
    HMI,
  },
});
